import rtc_logo from "./images/rtc_outline.png";
import codepath_logo from "./images/codepath_logo.png";
import stem_for_her from "./images/stem_for_her.png";
import coding_it_forward from "./images/cif_logo.png";
import bridges_to_independence from "./images/bridges_to_independence.png";
import miriams_kitchen from "./images/miriams_kitchen.png";
import afac from "./images/afac.png";
import ctl from "./images/ctl_logo.png";

export const mentoring = [
    {
        jobTitle: "Rewriting the Code",
        companyName: "https://rewritingthecode.org/",
        location: "",
        startDate: "Sep 2020",
        endDate: "Present",
        skills: [],
        tasks: [
            "Serve as mentor to 15+ college women interested in pursuing careers in tech field by conducting resume reviews & mock interviews, providing career advice, & guiding practice projects to build their skills"
        ],
        logo: rtc_logo
    },
    {
        jobTitle: "CodePath",
        companyName: "https://www.codepath.org/",
        location: "",
        startDate: "Jun 2024",
        endDate: "Present",
        skills: [],
        tasks: [
            "Coach 10 students during 10-week Technical Interview Prep course to guide students through effectively solving common data structures and algorithms problems to prepare for technical interviews",
            "Mentor students from diverse backgrounds by teaching key skills needed for software engineering jobs, including SQL & Python",
            "Conduct mock interviews & resume reviews with 5 students per quarter to ensure best chance at securing job"
        ],
        logo: codepath_logo
    },
    {
        jobTitle: "STEM for Her",
        companyName: "https://stemforher.org/",
        location: "",
        startDate: "Feb 2025",
        endDate: "Present",
        skills: [],
        tasks: [
            "Mentor female student from underrepresented background who is pursuing technical degree by meeting on biweekly basis to provide advice and resources on various topics, including career paths and training"
        ],
        logo: stem_for_her
    },
    {
        jobTitle: "Coding it Forward",
        companyName: "https://codingitforward.com/",
        location: "",
        startDate: "Jun 2025",
        endDate: "Present",
        skills: [],
        tasks: [
            "Mentor female student interested in pursuing technical degree by meeting on biweekly basis to provide advice and resources on various topics, including career paths and training"
        ],
        logo: coding_it_forward
    },
    {
        jobTitle: "Bridges to Independence",
        companyName: "https://bridges2.org/",
        location: "",
        startDate: "Dec 2023",
        endDate: "Present",
        skills: [],
        tasks: [
            "Mentor middle school student living in homeless shelter on weekly basis by serving as stable, trusted point of contact, assisting with schoolwork and keeping student accountable, providing guidance on career paths of interest to motivate student to dream big and overcome their current situation, and engaging in fun activities to keep student active and promote a positive attitude despite their current circumstances"
        ],
        logo: bridges_to_independence
    },
];

export const volunteering = [
    {
        jobTitle: "Miriam's Kitchen",
        companyName: "https://www.miriamskitchen.org/",
        location: "",
        startDate: "Jan 2025",
        endDate: "Present",
        skills: [],
        tasks: [
            "Prepare and serve well-balanced, nutritious meals for 100+ homeless people in DC twice a month"
        ],
        logo: miriams_kitchen
    },
    {
        jobTitle: "Arlington Food Assistance Center (AFAC)",
        companyName: "https://afac.org/",
        location: "",
        startDate: "Feb 2025",
        endDate: "Present",
        skills: [],
        tasks: [
            "Enable low-income families in Arlington, VA to receive substantial, nutritious meals on weekly basis by sorting and distributing 100 lbs of donated food items per month",
        ],
        logo: afac
    },
    {
        jobTitle: "Crisis Text Line (CTL)",
        companyName: "https://www.crisistextline.org/",
        location: "",
        startDate: "Sep 2025",
        endDate: "Present",
        skills: [],
        tasks: [
            "Volunteer as crisis counselor to provide free, 24/7 support for people in crisis by texting with individuals to help them move from a hot moment to a cool moment through active listening and collaborative problem solving",
        ],
        logo: ctl
    },
]